export type PageVideoKey =
  | 'platform_intro'
  | 'dashboard'
  | 'betting_houses'
  | 'card_rules'
  | 'sports_bets'
  | 'surebets'
  | 'casino_bets'
  | 'calculators'
  | 'bank_accounts'
  | 'transactions'
  | 'reports'
  | 'partnerships'
  | 'goals';

export interface PageVideoDefinition {
  key: PageVideoKey;
  labelKey: string;
  descriptionKey: string;
}

export interface PageVideoRecord extends PageVideoDefinition {
  label: string;
  description: string;
  youtube_url: string | null;
  media_url: string | null;
  cover_url: string | null;
  is_active: boolean;
}

export const MEDIA_LIBRARY_ORIGIN = 'https://media.greenpro.com.br/';

export const PAGE_VIDEO_DEFINITIONS: PageVideoDefinition[] = [
  {
    key: 'platform_intro',
    labelKey: 'pageVideos.platform_intro.label',
    descriptionKey: 'pageVideos.platform_intro.description',
  },
  {
    key: 'dashboard',
    labelKey: 'pageVideos.dashboard.label',
    descriptionKey: 'pageVideos.dashboard.description',
  },
  {
    key: 'betting_houses',
    labelKey: 'pageVideos.betting_houses.label',
    descriptionKey: 'pageVideos.betting_houses.description',
  },
  {
    key: 'card_rules',
    labelKey: 'pageVideos.card_rules.label',
    descriptionKey: 'pageVideos.card_rules.description',
  },
  {
    key: 'sports_bets',
    labelKey: 'pageVideos.sports_bets.label',
    descriptionKey: 'pageVideos.sports_bets.description',
  },
  {
    key: 'surebets',
    labelKey: 'pageVideos.surebets.label',
    descriptionKey: 'pageVideos.surebets.description',
  },
  {
    key: 'casino_bets',
    labelKey: 'pageVideos.casino_bets.label',
    descriptionKey: 'pageVideos.casino_bets.description',
  },
  {
    key: 'calculators',
    labelKey: 'pageVideos.calculators.label',
    descriptionKey: 'pageVideos.calculators.description',
  },
  {
    key: 'bank_accounts',
    labelKey: 'pageVideos.bank_accounts.label',
    descriptionKey: 'pageVideos.bank_accounts.description',
  },
  {
    key: 'transactions',
    labelKey: 'pageVideos.transactions.label',
    descriptionKey: 'pageVideos.transactions.description',
  },
  {
    key: 'reports',
    labelKey: 'pageVideos.reports.label',
    descriptionKey: 'pageVideos.reports.description',
  },
  {
    key: 'partnerships',
    labelKey: 'pageVideos.partnerships.label',
    descriptionKey: 'pageVideos.partnerships.description',
  },
  {
    key: 'goals',
    labelKey: 'pageVideos.goals.label',
    descriptionKey: 'pageVideos.goals.description',
  },
];

const PAGE_VIDEO_DEFINITION_MAP = new Map<PageVideoKey, PageVideoDefinition>(
  PAGE_VIDEO_DEFINITIONS.map((definition) => [definition.key, definition])
);

export function getPageVideoDefinition(key: PageVideoKey) {
  return PAGE_VIDEO_DEFINITION_MAP.get(key) || null;
}

export function normalizeVideoUrl(value: string | null | undefined) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';

  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
    return url.toString();
  } catch {
    return '';
  }
}

export function normalizeMediaAssetUrl(value: string | null | undefined) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';

  try {
    const mediaOrigin = new URL(MEDIA_LIBRARY_ORIGIN).origin;

    if (/^https?:\/\//i.test(trimmed)) {
      const url = new URL(trimmed);
      return url.origin === mediaOrigin ? url.toString() : '';
    }

    const normalizedPath = trimmed.replace(/^\/+/, '');
    return new URL(normalizedPath, MEDIA_LIBRARY_ORIGIN).toString();
  } catch {
    return '';
  }
}